import { connect } from "react-redux";
import { selectors } from "../../../app/slices/itemSlice";
import {
  createContribution,
  setPendingCommentSubmissionState,
  resetSkipAndTop,
  setReloadComments,
  dismissError,
} from "../../../app/slices/itemSlice";
import ReplyModal from "./ReplyModal";

const mapStateToProps = (state) => {
  return {
    pendingCommentSubmission: selectors.pendingCommentSubmission(state),
    maxChars: selectors.maxChars(state),
    pendingCommentSubmissionState: selectors.pendingCommentSubmissionState(
      state
    ),
    errors: selectors.errors(state),
    reloadComments: selectors.reloadComments(state)
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    createContribution: (data) => dispatch(createContribution(data)),
    setPendingCommentSubmissionState: (status) =>
      dispatch(setPendingCommentSubmissionState(status)),
    dismissError: () => dispatch(dismissError()),
    resetSkipAndTop: () => dispatch(resetSkipAndTop()),
    setReloadComments: (reloadComments) => dispatch(setReloadComments(reloadComments))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ReplyModal);
